<template>
  <button
    v-on:click="buttonClick"
    :disabled="disabled"
    class="add-to-cart-btn"
    type="button"
  >
      <img title="Add to cart" src="/ui/main/img/add_to_cart.svg" alt="Add to cart" loading="lazy" width="29" height="35" class="img-fluid">
  </button>
</template>

<script>
import store from '../../../vue/store'

export default {
  name: 'AdvButton',
  props: {
    productId: Number,
    quantity: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    attributeIdsWithStock: {
      type: Array,
      default: () => []
    },
    productMetaData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    },
    hasAttributes () {
      return this.productData.productCodes.length > 1
    }
  },
  methods: {
    buttonClick () {
      this.$emit('btn-click')
      const productPrice = this.productData.productFinalPrice
      const barcode = this.productData.barCodes[0]
      const productQuantity = this.quantity

      const pixieEventOptions = {
        value: productPrice,
        currency: 'EUR',
        OrderID: barcode,
        Quantity: productQuantity
      }

      const taboolaEventOptions = {
        notify: 'event',
        name: 'add_to_cart',
        revenue: productPrice,
        orderid: barcode,
        currency: 'EUR',
        quantity: productQuantity
      }

      document.dispatchEvent(new CustomEvent('pixieAddToCart', {
        detail: {
          data: pixieEventOptions
        }
      }))

      document.dispatchEvent(new CustomEvent('taboolaAddToCart', {
        detail: {
          data: taboolaEventOptions
        }
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart-btn {
  position: relative;
  overflow: hidden;
  height:36px;
  &::after {
    content: "+";
    position: absolute;
    top: 60%;
    left: 28px;
    transform: translate(-50%, -50%) scale(0);
    font-size: 26px;
    color: #000;
    width: 21px;
    height: 21px;
    line-height: 0.8;
    border-radius: 50%;
    font-weight: 700;
    background: white;
    transition: transform 0.3s ease-in-out;
    pointer-events: none;
    @media screen and (max-width:1199px){
      display:none;
    }
  }

  &:hover::after {
    @media screen and (min-width:1200px){
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
